import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {ButtonToolbar, Button, Input} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, controlledField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import {ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED, sendAnswerChallengeTicketClaimCmd, loadTicketClaim} from '../actions'
import {AnswerChallengeTicketClaimCmd} from '../models'
import i18n from '../i18n'

class AnswerChallengeTicketClaimForm extends Component {
    static propTypes = {
    }

    _sendCmd() {
        const {dispatch} = this.props

        return dispatch(sendAnswerChallengeTicketClaimCmd()).then(() => {
            return dispatch(loadTicketClaim())
        })
    }

    render() {
        const {dispatch, form, cmd} = this.props

        return (
            <div>
                <form>
                    <Input
                        type='textarea'
                        rows={4}
                        placeholder={i18n.answerChallengeTicketClaim + ' *'}
                        {...controlledField(form.comment())} />
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </LoaderButton>
                </ButtonToolbar>
            </div>
        )
    }
}

AnswerChallengeTicketClaimForm = connectForm({
    target: 'cmd',
    schema: AnswerChallengeTicketClaimCmd.schema,
    action: ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED
})(AnswerChallengeTicketClaimForm)

AnswerChallengeTicketClaimForm = connect((state) => ({
    cmd: state.claim.answerChallengeTicketClaimCmd
}))(AnswerChallengeTicketClaimForm)

export default AnswerChallengeTicketClaimForm


// WEBPACK FOOTER //
// ./lib/claim/components/AnswerChallengeTicketClaimForm.js